(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SgzHeader extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('.sgzhdr__burger');
      this.drops = Array.from(this.querySelectorAll('[data-sgz-drop]'));

      if (this.burger) {
        this.burger.addEventListener('click', () => {
          const open = this.classList.toggle('is-mobile-open');
          this.burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      // Mobile Sprache/Land: Auswahl per <select> sofort absenden
      this.querySelectorAll('[data-sgz-locselect]').forEach((sel) => {
        sel.addEventListener('change', () => { if (sel.form) sel.form.submit(); });
      });

      this.drops.forEach((drop) => {
        const trigger = drop.querySelector('.sgzhdr__pill--drop');
        if (!trigger) return;
        // Hover-Intent: Öffnen sofort, Schliessen mit kurzer Verzögerung.
        // Die Verzögerung überbrückt die 10px-Lücke zwischen Pille und Dropdown
        // (mouseleave feuert kurz beim Überqueren) und schliesst zuverlässig,
        // sobald die Maus das Menü wirklich verlässt — ohne CSS-Brücke.
        let closeTimer = null;
        const cancelClose = () => { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } };
        const open = () => { cancelClose(); drop.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
        const closeNow = () => { cancelClose(); drop.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
        const scheduleClose = () => { cancelClose(); closeTimer = setTimeout(closeNow, 180); };
        drop.addEventListener('mouseenter', open);
        drop.addEventListener('mouseleave', scheduleClose);
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          drop.classList.contains('is-open') ? closeNow() : open();
        });
        trigger.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeNow(); trigger.focus(); } });

        // Länder-Suche: filtert die Einträge live (Dropdown bleibt per Hover offen)
        const search = drop.querySelector('[data-sgz-locsearch]');
        if (search) {
          const items = Array.from(drop.querySelectorAll('[data-sgz-country]'));
          const empty = drop.querySelector('[data-sgz-country-empty]');
          search.addEventListener('input', () => {
            const term = search.value.trim().toLowerCase();
            let visible = 0;
            items.forEach((item) => {
              const match = item.textContent.toLowerCase().indexOf(term) !== -1;
              item.style.display = match ? '' : 'none';
              if (match) visible += 1;
            });
            if (empty) empty.hidden = visible !== 0;
          });
          search.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeNow(); trigger.focus(); } });
        }
      });

      this._onDocClick = (e) => {
        if (!this.contains(e.target)) this.drops.forEach((d) => {
          d.classList.remove('is-open');
          const t = d.querySelector('.sgzhdr__pill--drop');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      };
      document.addEventListener('click', this._onDocClick);
    }
    disconnectedCallback() { document.removeEventListener('click', this._onDocClick); }
  }
  customElements.define('sgz-header', SgzHeader);

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
